<template>
  <div class="footer-search">
    <div class="img-wrapper">
      <img
        src="https://static.max-c.com/static/heybox/webapp/game/palworld/database/footer.png"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.footer-search {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 20px 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .img-wrapper {
    height: 18px;
    img {
      height: 18px;
    }
  }
}
</style>
